import React from "react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Search, Filter } from "lucide-react";

interface FilterSectionProps {
  nameValue: string;
  phoneValue: string;
  emrValue: string;
  onNameChange: (value: string) => void;
  onPhoneChange: (value: string) => void;
  onEmrChange: (value: string) => void;
  onSearch: () => void;
  onFilter: () => void;
}

export const FilterSection: React.FC<FilterSectionProps> = ({
  nameValue,
  phoneValue,
  emrValue,
  onNameChange,
  onPhoneChange,
  onEmrChange,
  onSearch,
  onFilter,
}) => {
  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      onSearch();
    }
  };

  return (
    <div className="flex gap-4 items-end">
      <div className="flex gap-4 flex-1 items-end bg-background border rounded-lg p-6 space-y-4">
        <div className="flex-1 grid grid-cols-1 md:grid-cols-3 gap-4">
          <div className="space-y-2">
            <label className="text-sm font-medium text-foreground">Name</label>
            <Input
              placeholder="Search by name"
              value={nameValue}
              onChange={(e) => onNameChange(e.target.value)}
              onKeyDown={handleKeyDown}
              className="w-full"
            />
          </div>
          <div className="space-y-2">
            <label className="text-sm font-medium text-foreground">Phone Number</label>
            <Input
              placeholder="Search by Phone Number"
              value={phoneValue}
              onChange={(e) => onPhoneChange(e.target.value)}
              onKeyDown={handleKeyDown}
              className="w-full"
            />
          </div>
          <div className="space-y-2">
            <label className="text-sm font-medium text-foreground">EMR</label>
            <Input
              placeholder="Search by EMR"
              value={emrValue}
              onChange={(e) => onEmrChange(e.target.value)}
              onKeyDown={handleKeyDown}
              className="w-full"
            />
          </div>
        </div>
        <div className="flex gap-3 pt-2">
          <Button onClick={onSearch} className="w-40">
            <Search className="h-4 w-4 mr-2" />
            Search
          </Button>
        </div>
      </div>
      <div className="py-6">
      <Button onClick={onFilter} className="w-40">
        <Filter className="h-4 w-4 mr-2" />
        Filter
      </Button>
      </div>
    </div>
  );
};